<template>
  <div class="News" id="News">
    <v-app>
      <v-app-bar app color='primary' dark height="564" absolute>
        <v-row align="start">
          <!-- 一级导航栏 -->
          <FirstNavbar :pc='pc' :tab_index="first_active_tab" :barHide="barHide" :barColor="barColor"></FirstNavbar>
          <div class='first_title_box'  style="width:100%;height:calc(564px - 64px);" >
            <v-row align="center" justify="center">
              <v-col cols="12">
                <h1 class="first_title white--text">
                  新闻中心
                </h1>
                <h4 class="body_text white--text">
                  <span>诚信</span><span>规范</span><span>创新</span><span>高效</span>
                </h4>
              </v-col>
            </v-row>
          </div>
          <!-- 首屏大图 -->
          <div style="width:100%;height:500px;position:absolute;z-index:-3;margin-left:-4px">
            <v-parallax height="564" dark src="../assets/images/bg_news.png">
            </v-parallax>
          </div>
        </v-row>
      </v-app-bar>
      <v-main>
        <div class="aboutContent">
          <v-row dense>
            <v-col cols="12" style='padding:2rem'>
              <div class="titleBox" id="part1" style="margin-bottom:2rem">
                <h1 class="second_title font-weight-thin lg-4" >
                  {{news.xwbt}}
                </h1>
              </div>
              <div class="text-center" style='margin-bottom:2rem' v-html='news.fbdate'>
              </div>
              <div class='news_content' v-html='news.xwzw'>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-main>
    <v-footer  color="secondary" style="height:auto">
      <FootContent :active="footList.active" :listWidth="footList.listWidth"></FootContent>
    </v-footer>
    </v-app>
  </div>
</template>

<script>
import FootContent from '../components/footer.vue'
import FirstNavbar from '../components/first-navbar.vue'

export default {
  name: 'News',

  components: {
    FootContent,
    FirstNavbar
  },
  data: () => ({
    // 新闻
    news: {},
    // 导航背景颜色
    barColor: 'rgba(63, 81, 181,0)',
    // 导航栏是否隐藏
    barHide: true,
    // 是否为PC端
    pc: false,
    // 悬浮按钮是否隐藏
    floatHidden: true,
    // 页脚参数
    footList: {
      listWidth: '10rem',
      active: [true, true, true]
    },
    // 一级导航选项卡
    first_active_tab: 5,
    page: 1,
    items: []
  }),
  created () {
    this.$nextTick(() => {
      this.getNews()
    })
  },
  mounted () {
    this.goTo(0)
    var that = this
    that.whatScreen()
    // 屏幕尺寸监听
    window.onresize = function () {
      that.whatScreen()
    }
  },
  methods: {
    // 屏幕
    whatScreen () {
      var width = document.querySelector('html').offsetWidth
      if (width <= 768) {
        // title.innerHTML = "极小屏幕-" + width
        this.footList.active = [false, false, false]
        this.footList.listWidth = '90rem'
        this.pc = false
      } else {
        if (width > 768 && width <= 992) {
          // title.innerHTML = "小屏幕-" + width
          this.footList.active = [true, true, true]
          this.footList.listWidth = '10rem'
          this.pc = false
        } else {
          if (width > 992 && width <= 1100) {
            // title.innerHTML = "普通屏幕-" + width
            this.footList.active = [true, true, true]
            this.footList.listWidth = '10rem'
            this.pc = true
          } else {
            if (width > 1200 && width <= 1600) {
              // title.innerHTML = "大屏幕-" + width
              this.footList.active = [true, true, true]
              this.footList.listWidth = '10rem'
              this.pc = true
            } else {
              if (width > 1600) {
                // title.innerHTML = "大屏幕-" + width
                this.footList.listWidth = '10rem'
                this.footList.active = [true, true, true]
                this.pc = true
              }
            }
          }
        }
      }
    },
    // 获取新闻
    async getNews () {
      await this.$axios.post('erp/f/web/getXwInfor?id=' + this.$route.query.id)
        .then(response => {
          response.data.xwzw = response.data.xwzw.replace(RegExp('src="', 'g'), 'src="' + this.baseUrl)
          this.news = response.data
        }).catch(
        )
    },
    // 一级导航跳转定位
    toguid (path_, id) {
      const path = path_
      const Id = id
      localStorage.setItem('toId', Id)
      this.$router.push(path)
    },
    goTo (ele) {
      document.body.scrollTop = ele
      document.documentElement.scrollTop = ele
    }
  }

}
</script>

<style>
.news_content p{
  /* text-align: left !important; */
  /* text-indent: 0; */
  background-color:transparent !important;
  font: normal normal 1rem/1.8rem arial,sans-serif !important;
  letter-spacing: .15rem !important;
}
.news_content span{
  background-color:transparent !important;
  font: normal normal 1rem/1.8rem arial,sans-serif !important;
}
.news_content a{
  text-decoration: none;
  color:black !important;
}
.news_content img{
  max-width:80% !important;
  height:auto !important;
  left:50%;
  transform: translateX(-50%);
  position:relative;
  margin:20px;
  display:block;
}

</style>
